import '../scss/click-details.scss';

import {
  dateFormats,
  materialUiColors
} from 'application/src/js/globals.js';
import {
  ajax,
  forceDatePickerRange,
  getDateString,
  randomValuesFromArray
} from 'application/src/js/functions.js';
import {
  DataStorage,
  Mediator,
  ModalWindow,
  Pagination,
  SpinnerOverlay,
  FlyoutMenu
} from 'application/src/js/util.js';
import ClicksHistoryChart from './click-details/clicks-history-chart.js';
import ClicksPerCountry from './click-details/clicks-per-country.js';
import ClicksPerValueAddedStep from './click-details/clicks-per-value-added-step.js';
import SingleClicksList from './click-details/single-clicks-list.js';
import TopInterestedList from './click-details/top-interested-list.js';
import ContactDetailsModal from './click-details/contact-details-modal.js';
import TopInterestedDetailsModal from './click-details/top-interested-details-modal.js';
import ProductSelection from './click-details/product-selection.js';
import reducer from './click-details/reducer.js';

moment.locale(selectedLanguage);

class ClicksList {
  constructor(args) {
    this.container = document.querySelector('.clicks-list');
    this.tabHead = this.container.querySelectorAll('.tab-head');
    this.tabContent = this.container.querySelectorAll('.top-interested-list, .single-clicks-list');
    this.activeClass = 'active';

    this.addEvents();
  }

  addEvents() {
    [...this.tabHead].map((tabHead, i) => {
      tabHead.addEventListener('click', e => {
        [...this.tabHead].map(th => th.classList.remove(this.activeClass));
        [...this.tabContent].map(tc => tc.classList.remove(this.activeClass));
        tabHead.classList.add(this.activeClass);
        [...this.tabContent][i].classList.add(this.activeClass);
      });
    });
  }
}

const datepickerOptions = {
  allowInput: true,
  altInput: true,
  altFormat: dateFormats[pageVar.selectedLanguage],
  dateFormat: 'Y-m-d',
  locale: pageVar.selectedLanguage
};

const loader = new SpinnerOverlay({
  element: document.querySelector('#loading-overlay')
});
const store = new DataStorage();
const mediator = new Mediator();

document.addEventListener('DOMContentLoaded', e => {
  const clicksList = new ClicksList({
    mediator: mediator
  });

  const contactDetailsModal = new ContactDetailsModal({
    mediator: mediator,
    modal: new ModalWindow(document.querySelector('.contact-details-modal'), {
      backgroundIsCloseTrigger: true
    }),
    translations: translations,
  });

  const topInterestedDetailsModal = new TopInterestedDetailsModal({
    loader: new SpinnerOverlay({
      element: document.querySelector('.top-interested-details-modal .overlay')
    }),
    mediator: mediator,
    modal: new ModalWindow(document.querySelector('.top-interested-details-modal'), {
      backgroundIsCloseTrigger: true
    }),
    store: store,
    translations: translations
  });

  new ClicksPerCountry({
    pagination: new Pagination({
      container: document.querySelector('.clicks-per-country .pagination')
    }),
    store: store,
    translations: translations
  });

  new ClicksPerValueAddedStep({
    colors: [
      materialUiColors.teal,
      materialUiColors.green,
      materialUiColors.lightGreen,
      materialUiColors.lime,
      materialUiColors.yellow,
      materialUiColors.amber,
      materialUiColors.orange
    ],
    randomValuesFromArray: randomValuesFromArray,
    store: store,
    translations: translations,
    outerContainer: document.querySelector('.clicks-per-vas')
  });

  new ClicksHistoryChart({
    baseColors: [
      materialUiColors.teal,
      materialUiColors.orange
    ],
    store: store
  });

  const productSelection = new ProductSelection({
    store: store
  });

  const singleClicksList = new SingleClicksList({
    contactDetailsModal: contactDetailsModal,
    productSelection: productSelection,
    translations: translations,
    store: store,
    pagination: new Pagination({
      container: document.querySelector('.single-clicks-list .pagination'),
      autoHide: true,
      noResultsMessage: document.querySelector('.single-clicks-list .no-results-message')
    }),
    statisticsStepsIdFilterDropdown: new FlyoutMenu({
      element: document.querySelector('.single-clicks-list .list-head .action .flyout-menu')
    })
  });

  const topInterestedList = new TopInterestedList({
    mediator: mediator,
    store: store,
    topInterestedDetailsModal: topInterestedDetailsModal,
    translations: translations,
    pagination: new Pagination({
      container: document.querySelector('.top-interested-list .pagination'),
      autoHide: true,
      noResultsMessage: document.querySelector('.top-interested-list .no-results-message')
    })
  });

  new ClickDetails({
    loader: loader,
    mediator: mediator,
    productSelection: productSelection,
    singleClicksList: singleClicksList,
    store: store
  });
});

class ClickDetails {
  constructor(args) {
    this.store = args.store;
    this.singleClicksList = args.singleClicksList;
    this.productSelection = args.productSelection;
    this.loader = args.loader;
    this.exportButton = this.singleClicksList.exportButton;
    this.container = document.querySelector('.data-filter');
    this.startDateInput = this.container.querySelector('[name="start_date"]');
    this.endDateInput = this.container.querySelector('[name="end_date"]');
    this.aggregatedAmountTotalOut = document.querySelectorAll('.num-aggregated-clicks-out');

    this.sortField = '';
    this.sortDir = '';
    this.statisticsStepIds = [];

    this.initDatePicker();
    this.addEvents();
    this.initLoad();
  }

  initDatePicker() {
    this.startDatePicker = flatpickr(
      this.startDateInput,
      Object.assign({},
        datepickerOptions, {
          maxDate: new Date().fp_incr(-2),
          onClose: (selectedDates, dateStr, instance) => {
            forceDatePickerRange(instance, this.endDatePicker, instance);
            if (this.store.getState().start_date == getDateString(selectedDates[0])) return;
            this.update();
          }
        }
      )
    );

    this.endDatePicker = flatpickr(
      this.endDateInput,
      Object.assign({},
        datepickerOptions, {
          maxDate: new Date().fp_incr(-1),
          onClose: (selectedDates, dateStr, instance) => {
            forceDatePickerRange(this.startDatePicker, instance, instance);
            if (this.store.getState().end_date == getDateString(selectedDates[0])) return;
            this.update();
          }
        }
      )
    );
  }

  addEvents() {
    this.singleClicksList.subscribe('action', (perPage, pageIndex, sortField, sortDir, statisticsStepIds) => {
      this.sortField = sortField;
      this.sortDir = sortDir;
      this.statisticsStepIds = statisticsStepIds;

      this.loader.show();

      this.loadDetailsStatistics({
          per_page: perPage,
          page_index: pageIndex
        })
        .then(response => {
          this.store.dispatch({
            type: 'UPDATE_SINGLE_CLICKS_LIST',
            payload: response.data
          });

          this.loader.hide();
        })
        .catch(e => console.log(e));
    });

    this.singleClicksList.subscribe('reloadList', (perPage, pageIndex, sortField, sortDir, statisticsStepIds) => {
      this.sortField = sortField;
      this.sortDir = sortDir;
      this.statisticsStepIds = statisticsStepIds;
      this.update();
    });

    if (this.exportButton) {
      this.exportButton.addEventListener('click', e => {
        const button = document.createElement('a');
        button.setAttribute('href', '/analytics/clickDetails/ajaxClickDetailsContactExport/?' + this.getUrlParams());
        button.setAttribute('style', 'display:none!important');
        button.innerHTML = '&nbsp';
        document.body.insertAdjacentElement('beforeend', button);
        button.click();
        button.parentNode.removeChild(button);
      });
    }

    this.productSelection.subscribe('change', (productIds, selectedProducts) => this.update());

    ['init', 'update'].map(eventType => {
      this.store.subscribe(eventType, e => {
        const aggregatedAmountTotal = Object.values(e.chart).reduce((totalAmount, productData) => {
          totalAmount += productData.clicks.reduce((totalProductClicks, clicks) => {
            totalProductClicks += parseInt(clicks.amount);
            return totalProductClicks;
          }, 0);

          return totalAmount;
        }, 0);

        Array.prototype.slice.call(this.aggregatedAmountTotalOut).map(element => element.innerHTML = aggregatedAmountTotal);
      });
    })
  }

  initLoad() {
    const params = this.getParams();

    Promise.all([
        this.loadDetailsStatistics(),
        this.loadDetailsStatistics({
          page_index: this.singleClicksList.pageIndex,
          per_page: this.singleClicksList.perPage,
        }),
        ajax('/analytics/clickDetails/ajaxLoadClickDailyStatistics', params),
        ajax('/analytics/clickDetails/ajaxLoadClickTopCompanies', params)
      ])
      .then(response => {
        this.store.init(reducer, {
          start_date: this.startDatePicker.selectedDates.length ? getDateString(this.startDatePicker.selectedDates[0]) : null,
          end_date: this.endDatePicker.selectedDates.length ? getDateString(this.endDatePicker.selectedDates[0]) : null,
          completeList: response[0].data,
          list: response[1].data,
          chart: response[2].data,
          topInterested: response[3].data,
          products: this.productSelection.selectedProducts,
          user: response[0].user
        });

        this.loader.hide();
      })
      .catch(e => console.log(e));
  }

  update() {
    this.loader.show();
    const params = this.getParams();

    Promise.all([
        this.loadDetailsStatistics(),
        this.loadDetailsStatistics({
          page_index: this.singleClicksList.pageIndex,
          per_page: this.singleClicksList.perPage,
        }),
        ajax('/analytics/clickDetails/ajaxLoadClickDailyStatistics', params),
        ajax('/analytics/clickDetails/ajaxLoadClickTopCompanies', params)
      ])
      .then(response => {
        this.store.dispatch({
          type: 'UPDATE',
          payload: {
            start_date: this.startDatePicker.selectedDates.length ? getDateString(this.startDatePicker.selectedDates[0]) : null,
            end_date: this.endDatePicker.selectedDates.length ? getDateString(this.endDatePicker.selectedDates[0]) : null,
            completeList: response[0].data,
            list: response[1].data,
            chart: response[2].data,
            topInterested: response[3].data,
            products: this.productSelection.selectedProducts
          }
        });

        this.loader.hide();
      })
      .catch(e => console.log(e));
  }

  loadDetailsStatistics(params = {}) {
    const generalParams = this.getParams();
    return ajax('/analytics/clickDetails/ajaxLoadClickDetailsStatistics',
      Object.assign({},
        generalParams,
        params
      )
    );
  }

  getParams() {
    let params = {};

    if (this.startDatePicker.selectedDates.length) {
      params.start_date = getDateString(this.startDatePicker.selectedDates[0]);
    }

    if (this.endDatePicker.selectedDates.length) {
      params.end_date = getDateString(this.endDatePicker.selectedDates[0]);
    }

    if (this.sortField) params.sort_field = this.sortField;
    if (this.sortDir) params.sort_dir = this.sortDir;
    if (this.statisticsStepIds) params.statistics_step_id = this.statisticsStepIds;

    params['products'] = Object.keys(this.productSelection.selectedProducts);

    return params;
  }

  getUrlParams() {
    let params = [];

    let products = this.productSelection.selectedProductIds.reduce((prev, curr) => {
      prev.push('products[]=' + curr);
      return prev;
    }, []);

    params.push(products.join('&'));
    params.push('start_date=' + this.startDateInput.value);
    params.push('end_date=' + this.endDateInput.value);

    return params.join('&');
  }
}